import React from 'react';

import { FeaturedCars, Heading } from '../../../components';



const HomeCars = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Featured Cars'} span={'Our Popular Collection'} />

      {/* Featured Cars Component */}
      <FeaturedCars />

    </section>

  );
}

export default HomeCars;